module.exports = __webpack_public_path__ + "img/electronics.6e1d00b0.png";